export default __webpack_public_path__ + "static/media/logo.d300383a.png";